<template>
    <aside
        :class="[
            'fixed inset-y-0 left-0 z-50 w-64 flex flex-col border-r border-primary-100 dark:border-primary-900 bg-primary-50 dark:bg-primary-950 transition-transform duration-200',
            'lg:relative lg:translate-x-0',
            mobileOpen ? 'translate-x-0' : '-translate-x-full'
        ]"
    >
        <div class="flex items-center gap-2 h-16 px-5 border-b border-primary-100 dark:border-primary-900">
            <span class="text-2xl">🍜</span>
            <span class="font-bold text-xl">NomNom</span>
        </div>

        <nav class="flex-1 overflow-y-auto p-3 flex flex-col gap-1">
            <RouterLink
                v-for="item in navItems"
                :key="item.name"
                :to="item.to"
                class="flex items-center gap-3 px-3 py-2.5 rounded-lg text-surface-700 dark:text-surface-300 hover:bg-primary-100 dark:hover:bg-primary-900/40 transition-colors"
                :class="{ 'bg-primary-100 dark:bg-primary-900/60 text-primary-700 dark:text-primary-300 font-medium': isActive(item.to) }"
                @click="mobileOpen = false"
            >
                <i :class="['pi', item.icon, 'text-lg w-5 text-center']" />
                <span>{{ item.label }}</span>
            </RouterLink>
        </nav>

        <div class="p-3 border-t border-primary-100 dark:border-primary-900">
            <button
                class="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-surface-600 dark:text-surface-400 hover:bg-primary-100 dark:hover:bg-primary-900/40 transition-colors"
                @click="logout"
            >
                <i class="pi pi-sign-out text-lg w-5 text-center" />
                <span>{{ t('auth.logout') }}</span>
            </button>
        </div>
    </aside>

    <div
        class="fixed inset-0 z-40 bg-black/50 lg:hidden transition-opacity duration-200"
        :class="mobileOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'"
        @click="mobileOpen = false"
    />
</template>

<script lang="ts" setup>
    import { inject, ref } from 'vue'
    import type { Ref } from 'vue'
    import { RouterLink, useRoute, useRouter } from 'vue-router'
    import { useI18n } from 'vue-i18n'

    import { useAppStore } from '@/stores/app'

    const { t }    = useI18n()
    const route    = useRoute()
    const router   = useRouter()
    const appStore = useAppStore()

    const mobileOpen = inject<Ref<boolean>>('mobileOpen', ref(false))

    const navItems = [
        { name: 'recipes',     to: '/recipes',     icon: 'pi-book',          label: t('nav.recipes') },
        { name: 'meal-plan',   to: '/meal-plan',   icon: 'pi-calendar',      label: t('nav.meal_plan') },
        { name: 'shopping',    to: '/shopping',    icon: 'pi-shopping-cart', label: t('nav.shopping') },
        { name: 'ingredients', to: '/ingredients', icon: 'pi-box',           label: t('nav.ingredients') },
        { name: 'tags',        to: '/tags',        icon: 'pi-tag',           label: t('nav.tags') },
        { name: 'profile',    to: '/profile',    icon: 'pi-user',          label: t('nav.profile') },
        { name: 'users',      to: '/users',      icon: 'pi-users',         label: t('nav.users') },
    ]

    const isActive = (path: string) => route.path.startsWith(path)

    const logout = () => {
        appStore.setLogout()
        router.push({ name: 'login' })
    }
</script>
